var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SuperBanner_1;
import * as React from "react";
import { observer } from "mobx-react";
import { scrollLeft, scrollRight, getBannerClasses, returnValueHelper, getMBNComponentHelper } from "../../helpers";
import { SelectionType, PaginationType, SiteDirection, EventTextTypeModifiers, SuperBannerJackpotItem } from "../../data";
// components
import { Animate, Icon, Img, BetBtn, Loader, FreeHtml, TooltipApi } from "sb-resp-ui";
import { eBranches } from "sb-helpers";
import { EventsManager } from "sb-js-extends";
// external components
import * as CMP from "./components";
import { TimestampFormatter } from "./helpers/TimeStampFormatter";
import { reaction } from "mobx";
/*
    Setup testing tools for MobX
    uncomment the <DevTools /> at the end of the SuperBanner component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
/* TODO(developer): refactor to lower cyclomatic complexity */
/* tslint:disable:cyclomatic-complexity */
let SuperBanner = SuperBanner_1 = class SuperBanner extends React.Component {
    constructor(props) {
        super(props);
        this.changePageClickHandler = (e) => {
            const target = e.target;
            const index = Number(target.dataset.pageId);
            this.changePage(index);
            this.autoLoopStop();
            this.setState({
                isClicked: true
            });
        };
        /* istanbul ignore next */
        this.onmousedown = (e) => {
            this.autoLoopStop();
            if (this.state.dataProvider.getInvisibleSpace(this.state.dataProvider.calcs) !== 0) {
                e.preventDefault();
                if (this.banner__wrapper) {
                    this.banner__wrapper.addEventListener("mousemove", this);
                    this.banner__wrapper.addEventListener("mouseup", this);
                    this.banner__wrapper.addEventListener("mouseleave", this);
                }
                this.dragStartX = (e.pageX - (this.anims[this.dirAnim] * this.dragDirectionFactor));
            }
        };
        /* istanbul ignore next */
        this.onmousemove = (e) => {
            e.preventDefault();
            let diff = (e.pageX - this.dragStartX) * this.dragDirectionFactor;
            if (Math.abs(diff) > 10) { // required to distinguish between drag and click events
                this.setState({
                    isDragging: true
                });
                this.anims[this.dirAnim] = diff;
                window["Velocity"](this.banner__container, {
                    [this.dirAnim]: this.anims[this.dirAnim]
                }, {
                    duration: 0
                });
            }
        };
        /* istanbul ignore next */
        this.onmouseup = (e) => {
            let progress = this.anims[this.dirAnim];
            let invisibleSpace = this.state.dataProvider.getInvisibleSpace(this.state.dataProvider.calcs);
            if (this.state.isDragging) {
                let index = this.changePage(this.state.dataProvider.getProgressPageIndex(this.state.dataProvider.calcs, progress));
                e.preventDefault();
                this.anims[this.dirAnim] = Math.min(Math.max(-index * this.state.dataProvider.calcs.step, -invisibleSpace), 0);
                this.setState(prevState => ({
                    anims: Object.assign(Object.assign({}, prevState.anims), { animation: {
                            [this.dirAnim]: `${this.anims[this.dirAnim]}px`
                        } })
                }));
                if (progress > 0 || progress < -invisibleSpace) {
                    // This is needed because if there isn't change in the state
                    // Velocity isn't called.
                    window["Velocity"](this.banner__container, {
                        [this.dirAnim]: this.anims[this.dirAnim]
                    }, {
                        duration: this.state.anims.duration
                    });
                }
            }
            if (this.banner__wrapper) {
                this.banner__wrapper.removeEventListener("mousemove", this);
                this.banner__wrapper.removeEventListener("mouseup", this);
                this.banner__wrapper.removeEventListener("mouseleave", this);
            }
            this.setState({
                isDragging: false,
                isClicked: true
            });
        };
        /* istanbul ignore next */
        this.onmouseleave = this.onmouseup;
        // setup dictionary
        this.dict = this.props.dict;
        /* istanbul ignore next */
        this.dirAnim = this.props.dataProvider.siteDirection;
        this.anims = {
            [this.dirAnim]: 0,
            animation: {
                [this.dirAnim]: 0
            }
        };
        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider,
            scrollable: {
                left: false,
                right: false
            },
            anims: {
                animation: Object.assign({}, this.anims.animation),
                duration: 350,
                easing: [10, 6],
                begin: props.dataProvider.updatePagination // always update pagination as it is the means to do autoloop
            },
            isDragging: false,
            isClicked: false
        };
        this.dragStartX = 0;
        this.dragDirectionFactor = this.dirAnim === SiteDirection.rightToLeft ? -1 : 1;
        this.cms = this.state.dataProvider.provider.dataFacade.cms;
        this.autoLoopTimeout = undefined;
        this.boundAutoLoopStart = this.autoLoopStart.bind(this);
        this.boundAutoLoopStop = this.autoLoopStop.bind(this);
        // :)
        // this.cms.UISetting.Pagination = false;
        // this.cms.UISetting.autoLoop.enabled = true;
        // this.cms.UISetting.autoLoop.duration = 1500;
        this.autoLoopPages = this.autoLoopPages.bind(this);
        this.isSingleItemOrMobileView = !this.cms.DisplayMultipleItems || this.cms.DisplayMobileMode;
        this.availItemsChangeDisposer = reaction(() => this.state.dataProvider.itemsToDisplay.length, _ => this.updateCalcs(), { delay: 500 });
        this.tooltip = TooltipApi.getInstance().setMessage(this.dict.TooltipMessage);
    }
    /*
        AutoLoop is ignored because it re-uses already tested logic
    */
    /* istanbul ignore next */
    autoLoopPages() {
        let page = this.state.dataProvider.currentPage + 1;
        this.changePage(page < this.state.dataProvider.pages.length ?
            page :
            0);
        return this.autoLoopStart();
    }
    /* istanbul ignore next */
    autoLoopStart() {
        this.autoLoopStop();
        if (this.state.isClicked) {
            return;
        }
        return this.autoLoopTimeout = setTimeout(this.autoLoopPages, this.cms.UISetting.autoLoop.duration);
    }
    /* istanbul ignore next */
    autoLoopStop() {
        clearInterval(this.autoLoopTimeout);
        this.autoLoopTimeout = undefined;
    }
    /* istanbul ignore next */
    // handlerOnClick() {
    //     return this.state.dataProvider.reset();
    // }
    renderLoader() {
        return (React.createElement("div", { className: "rj-superbanner__loader" },
            React.createElement(Loader, null)));
    }
    /* istanbul ignore next */
    renderBlockLoader() {
        this.resetScroll();
        return this.renderLoader();
    }
    /*
        scrollLeft() and scrollRight() are helpers and they are tested independently
        whether they return correct results
    */
    /* istanbul ignore next */
    scrollLeft() {
        let animationLeft = scrollLeft(this.anims, this.state.dataProvider.calcs, this.state.anims, this.dirAnim);
        if (this.state.scrollable.left) {
            this.setState(animationLeft);
            this.state.dataProvider.setCurrentPage(-1);
        }
    }
    /* istanbul ignore next */
    scrollRight() {
        let animationRight = scrollRight(this.anims, this.state.dataProvider.calcs, this.state.anims, this.dirAnim);
        if (this.state.scrollable.right) {
            this.setState(animationRight);
            this.state.dataProvider.setCurrentPage(1);
        }
    }
    changePage(x) {
        this.state.dataProvider.setSlideMultiplier(Math.abs(x - this.state.dataProvider.currentPage));
        x > this.state.dataProvider.currentPage ? this.scrollRight() : this.scrollLeft();
        this.state.dataProvider.updateCurrentPage(x);
        return x;
    }
    onClickArrowsHandler(direction, e) {
        /* istanbul ignore next */
        this.autoLoopStop();
        this.setState({
            isClicked: true
        });
        return this["scroll" + direction]();
    }
    // to be used for routing between captured events
    /* istanbul ignore next */
    handleEvent(e) {
        /* istanbul ignore next */
        typeof this[`on${e.type}`] === "function" && this[`on${e.type}`](e);
        if (e.type === "resize") {
            this.resetScroll();
            this.shouldScroll();
        }
    }
    /* istanbul ignore next */
    resetScroll() {
        this.anims[this.dirAnim] = 0;
        this.setState({ anims: Object.assign(Object.assign({}, this.state.anims), { animation: this.anims.animation }) });
        this.state.dataProvider.setupCalcs(this.banner__wrapper, this.banner__container, this.cms.DisplayMultipleItems);
        this.state.dataProvider.currentPage = 0;
        this.state.dataProvider.updatePagination();
    }
    /* istanbul ignore next */
    shouldScroll() {
        if (this.banner__container && this.banner__wrapper) {
            let sLeft = this.anims[this.dirAnim] < 0 ? true : false;
            let sRight = this.state.dataProvider.calcs.container -
                this.state.dataProvider.calcs.wrapper + this.anims[this.dirAnim] > 0 ? true : false;
            if (this.state.scrollable.left !== sLeft ||
                this.state.scrollable.right !== sRight) {
                this.setState({
                    scrollable: {
                        left: sLeft,
                        right: sRight
                    }
                });
            }
        }
    }
    updateCalcs() {
        this.state.dataProvider.setupCalcs(this.banner__wrapper, this.banner__container, this.cms.DisplayMultipleItems);
        this.state.dataProvider.updatePagination();
        this.shouldScroll();
    }
    /* istanbul ignore next */
    componentWillUnmount() {
        if (this.state.dataProvider.deviceDetect.isDesktop) {
            window.removeEventListener("resize", this);
            SuperBanner_1.eventsManager.removeEventListener("onSideVisibilityChange", this, true);
            SuperBanner_1.eventsManager.removeEventListener("onBranchChanged", this, true);
            SuperBanner_1.eventsManager.removeEventListener("onBranchRemoved", this, true);
            this.autoLoopStop();
            this.resetScroll();
            this.cms.UISetting.Draggable && this.banner__wrapper &&
                this.banner__wrapper.removeEventListener("mousedown", this);
        }
        this.availItemsChangeDisposer();
    }
    /* istanbul ignore next */
    componentDidMount() {
        if (this.state.dataProvider.deviceDetect.isDesktop) {
            this.updateCalcs();
            window.addEventListener("resize", this);
            SuperBanner_1.eventsManager.addEventListener("onSideVisibilityChange", this, this.updateCalcs, true);
            SuperBanner_1.eventsManager.addEventListener("onBranchChanged", this, this.resetScroll, true);
            SuperBanner_1.eventsManager.addEventListener("onBranchRemoved", this, this.resetScroll, true);
            this.cms.UISetting.autoLoop.enabled && this.autoLoopStart();
            this.cms.UISetting.Draggable && this.banner__wrapper &&
                this.banner__wrapper.addEventListener("mousedown", this);
        }
    }
    /* istanbul ignore next */
    componentDidUpdate(prevProps, prevState) {
        if (this.state.dataProvider.deviceDetect.isDesktop) {
            this.state.dataProvider.setupCalcs(this.banner__wrapper, this.banner__container, this.cms.DisplayMultipleItems);
            this.shouldScroll();
        }
    }
    /* istanbul ignore next */
    renderSuperbannerItems(items) {
        return (items.length === 0 ? this.renderLoader() :
            items.map((item) => {
                if (item instanceof SuperBannerJackpotItem) {
                    return (React.createElement(CMP.SuperBannerItem, { key: item.Id, clientHashedClass: item.ClientHashClass, clientHashedAttribute: item.ClientHashAttribute, width: this.state.dataProvider.itemWidth },
                        item.IsLoading && this.renderLoader(),
                        this.renderSuperBannerJackpotItem(item)));
                }
                if ((this.cms.DisplayMultipleItems || this.cms.DisplayMobileMode)
                    && item.PickedEvent
                    && item.PickedEvent.IsOutright) {
                    return (React.createElement(CMP.SuperBannerItem, { key: item.Id, clientHashedClass: item.ClientHashClass, clientHashedAttribute: item.ClientHashAttribute, modifier: !this.cms.DisplayMobileMode ?
                            this.state.dataProvider.getSuperBannerItemModifier(item) : "", width: this.state.dataProvider.itemWidth },
                        item.IsLoading && this.renderLoader(),
                        this.renderSuperBannerEvent(item.PickedEvent)));
                }
                return (React.createElement(CMP.SuperBannerItem, { key: item.Id, clientHashedClass: item.ClientHashClass, clientHashedAttribute: item.ClientHashAttribute, modifier: this.state.dataProvider.getSuperBannerItemModifier(item), width: this.state.dataProvider.itemWidth },
                    item.IsLoading &&
                        this.renderLoader(),
                    !this.cms.DisplayMobileMode &&
                        this.renderSuperBannerImage(item),
                    item.PickedEvent &&
                        this.renderSuperBannerEvent(item.PickedEvent)));
            }));
    }
    renderSuperBannerJackpotItem(item) {
        const JackpotComponent = window["JackpotComponent"];
        if (!JackpotComponent) {
            item.toggleAvailableState(false);
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(JackpotComponent, { cms: item.cmsConfig, dict: this.dict, isAvailableCallbackFn: item.toggleAvailableState }));
    }
    /* istanbul ignore next */
    renderSuperBannerImage(item) {
        const isPickedEv = !!item.PickedEvent && !!item.PickedEvent.event, IsOutright = !!item.PickedEvent && !!item.PickedEvent.IsOutright, isLive = isPickedEv && item.PickedEvent.event.isLive, hasLivestream = !!item.PickedEvent && !!item.PickedEvent.HasLivestream, leagueName = isPickedEv && item.PickedEvent.event.leagueName, height = this.state.dataProvider.getImageHeight(item, this.cms), anchorStyle = { height, width: "100%" }, isMBNEnabled = this.state.dataProvider.provider.dataFacade.isMBNEnabled;
        let link = item.PickedEvent ? item.PickedEvent.Link : "#";
        let clsMdf = isMBNEnabled && (hasLivestream || isLive) ? "rj-superbaner__icon rj-superbaner__icon--minbet-number-live-stream" : "rj-superbaner__icon";
        const mbnComponent = getMBNComponentHelper(item.PickedEvent, isMBNEnabled);
        return (React.createElement("div", { className: "rj-superbanner__image-row", "data-uat": "superbanner-image-row" },
            React.createElement("a", { className: "rj-superbanner__img-link", href: link, onClick: this.state.dataProvider.provider.imageClickHandler.bind(this.state.dataProvider.provider, item), style: anchorStyle, "data-uat": "link-superbanner-img" },
                React.createElement(Img, { width: "100%", height: height, src: item.Image ? item.Image.Src : "", fallbackSrc: "/imgs/i/o/superbanner/fallback.svg" }),
                (!this.isSingleItemOrMobileView && !IsOutright) && React.createElement(CMP.EventText, { text: leagueName, modifier: [`img-${EventTextTypeModifiers.modifierLeague}`] }),
                React.createElement("div", { className: clsMdf, "data-uat": "wrapper-superbaner-icon-live" },
                    mbnComponent,
                    isLive && React.createElement(CMP.LiveIndicator, { liveText: this.dict.LiveIndicator }),
                    hasLivestream && React.createElement("div", Object.assign({ className: "rj-superbaner__icon-live-stream-wrapper" }, this.tooltip),
                        React.createElement(Icon, { i: "i-24-16 i-o-ev-alt-streaming rj-superbaner__icon-live-stream " })))),
            this.state.dataProvider.showFreeHtml(item) && React.createElement(FreeHtml, { html: item.FreeHtmlText })));
    }
    renderSuperBannerEvent(pickedEvent) {
        let event = pickedEvent.event;
        let market = pickedEvent.market;
        let boundOpenGameTranspiler = this.state.dataProvider.provider.openGameTranspiler.bind(this.state.dataProvider.provider, pickedEvent);
        let boundOpenGameRace = this.state.dataProvider.provider.openRaceGame.bind(pickedEvent.Link);
        if (event && market) {
            let hasPossession = this.state.dataProvider.eventHasStarted(event) && event.sportID === eBranches.Tennis.toString();
            let possessionMdf = returnValueHelper(hasPossession, "possession", "");
            let outrightMdf = returnValueHelper(pickedEvent.IsOutright, "outright", "");
            let formatter = new TimestampFormatter(event, this.dict);
            let obj = {
                boundOpenGameTranspiler,
                pickedEvent,
                event,
                market,
                scoreboarProps: {
                    scoreFirstPlayer: event.scoreboard && event.scoreboard.additionalScoreData1 || [],
                    scoreSecondPlayer: event.scoreboard && event.scoreboard.additionalScoreData2 || [],
                    totalFirstPlayer: event.score1 && event.score1 || "",
                    totalSecondPlayer: event.score2 && event.score2 || "",
                    modifier: "superbanner"
                },
                hasPossession,
                onService: event.scoreboard && event.scoreboard.onServe,
                eventHasStarted: this.state.dataProvider.eventHasStarted(event),
                hasLiveScb: this.state.dataProvider.eventHasLiveScb(event),
                eventTextMdf: outrightMdf || possessionMdf,
                isMobileView: this.cms.DisplayMobileMode,
                liveIndicatorText: this.dict.LiveIndicator,
                modifierDatePeriodTimes: formatter.modifierDatePeriodTimes,
                modifierTimeScore: formatter.modifierTimeScore,
                textDatePeriodTime: formatter.textDatePeriodTime,
                textTimeScore: formatter.textTimeScore,
                tags: market.tags,
                isMBNEnabled: this.state.dataProvider.provider.dataFacade.isMBNEnabled
            };
            return (React.createElement("div", { className: "rj-superbanner__event-container", "data-uat": "superbanner-event-container" },
                React.createElement(CMP.EventInfo, { link: pickedEvent.Link, modifier: outrightMdf, handler: returnValueHelper((event.sportID === eBranches.HorseRacing.toString() || event.sportID === eBranches.GreyHoundsRacing.toString()), boundOpenGameRace, obj.boundOpenGameTranspiler) },
                    returnValueHelper(this.isSingleItemOrMobileView, React.createElement(CMP.EventInfoSingleItemOrMobileView, Object.assign({}, obj)), React.createElement(CMP.EventInfoMultipleItems, Object.assign({}, obj))),
                    pickedEvent.IsOutright && React.createElement(Icon, { i: `i-24 i-o-sport-${event.sportID} rj-superbanner__sport-icon` }) || ""),
                this.renderBetButtons(pickedEvent)));
        }
        return false;
    }
    renderBetButtons(pickedEvent) {
        if (pickedEvent.market && pickedEvent.market.type) {
            switch (pickedEvent.market.type) {
                case SelectionType.ML:
                case SelectionType.MLET:
                case SelectionType.PW:
                case SelectionType.TQ:
                    return this.renderML(pickedEvent);
                case SelectionType.HC:
                    return this.renderHC(pickedEvent);
                case SelectionType.OU:
                case SelectionType.TGET:
                    return this.renderOU(pickedEvent);
                case SelectionType.QA:
                    return this.renderOutright(pickedEvent);
                default:
                    throw Error("Not implemented render method for this selection type");
            }
        }
        return false;
    }
    renderML(pickedEvent) {
        let masterEvent = pickedEvent.event;
        let market = pickedEvent.market;
        const containerMLClass = returnValueHelper(this.state.dataProvider.oddsFormatter.ML.isRegular(market), "event-money-line-draw", "event-money-line");
        return (React.createElement("div", { className: `rj-superbanner__event-row rj-superbanner__event-row--${containerMLClass}`, "data-uat": `superbanner-event-row-${containerMLClass}` }, market.selections.map((sel) => (React.createElement("div", { key: sel.id, className: "rj-superbanner__bet-button-wrapper", "data-uat": "wrapper-superbanner-bet-button" },
            React.createElement(BetBtn, { type: "bet_btn--ML", modifier: this.state.dataProvider
                    .getBetBtnModifier(sel, market.type), odd: sel.formattedOdds, text: this.state.dataProvider.oddsFormatter.ML.getOddName(sel, !this.cms.DisplayMultipleItems), isDisabled: sel.isDisabled, handler: this.getOnBetBtnClickHandler(sel, masterEvent.id, market.id) }))))));
    }
    renderHC(pickedEvent) {
        let masterEvent = pickedEvent.event;
        let market = pickedEvent.market;
        return (React.createElement("div", { className: "rj-superbanner__event-row rj-superbanner__event-row--event-handicap", "data-uat": "superbanner-event-row-handicap" }, market.selections
            .slice(0, 2)
            .map((sel) => (React.createElement("div", { key: sel.id, className: "rj-superbanner__bet-button-wrapper", "data-uat": "wrapper-superbanner-bet-button" },
            React.createElement(BetBtn, { type: "bet_btn--HC", modifier: this.state.dataProvider
                    .getBetBtnModifier(sel, market.type), point: sel.formattedPoint, odd: sel.formattedOdds, text: sel.title, isDisabled: sel.isDisabled, handler: this.getOnBetBtnClickHandler(sel, masterEvent.id, market.id) }))))));
    }
    renderOU(pickedEvent) {
        let masterEvent = pickedEvent.event;
        let market = pickedEvent.market;
        return (React.createElement("div", { className: "rj-superbanner__event-row rj-superbanner__event-row--event-over-under", "data-uat": "superbanner-event-row-over-under" }, market.selections
            .slice(0, 2)
            .map((sel) => (React.createElement("div", { key: sel.id, className: "rj-superbanner__bet-button-wrapper", "data-uat": "wrapper-superbanner-bet-button" },
            React.createElement(BetBtn, { type: "bet_btn--OU", modifier: this.state.dataProvider
                    .getBetBtnModifier(sel, market.type), point: sel.formattedPoint, odd: sel.formattedOdds, text: sel.title, isDisabled: sel.isDisabled, handler: this.getOnBetBtnClickHandler(sel, masterEvent.id, market.id) }))))));
    }
    renderOutright(pickedEvent) {
        let event = pickedEvent.event;
        let market = pickedEvent.market;
        return (React.createElement("div", { className: "rj-superbanner__event-row rj-superbanner__event-row--event-outright", "data-uat": "superbanner-event-row-event-outright" },
            React.createElement("div", { className: "rj-superbanner__bet-btn-container" },
                this.state.dataProvider.oddsFormatter.Outright.getOdds(market, this.cms.DisplayMobileMode)
                    .map(sel => {
                    return (React.createElement("div", { key: sel.id, className: "rj-superbanner__bet-button-wrapper", "data-uat": "wrapper-superbanner-bet-button" },
                        React.createElement(BetBtn, { type: "bet_btn--QA", modifier: this.state.dataProvider
                                .getBetBtnModifier(sel, market.type), odd: sel.formattedOdds, text: sel.title, isDisabled: sel.isDisabled, handler: this.getOnBetBtnClickHandler(sel, event.id, market.id) })));
                }),
                returnValueHelper(this.state.dataProvider.oddsFormatter.Outright.showViewAll(market, this.cms.DisplayMobileMode), React.createElement("div", { className: "rj-superbanner__view-all-wrapper" },
                    React.createElement(CMP.ViewAllButton, { handler: returnValueHelper((event.sportID === eBranches.HorseRacing.toString() || event.sportID === eBranches.GreyHoundsRacing.toString()), this.state.dataProvider.provider.openRaceGame.bind(pickedEvent.Link), this.state.dataProvider.provider.openGameTranspiler.bind(this.state.dataProvider.provider, pickedEvent)), link: pickedEvent.Link, text: this.dict.ViewAllButton })), false))));
    }
    /* istanbul ignore next */
    getOnBetBtnClickHandler(selection, eventId, marketId) {
        /* istanbul ignore next */
        return (() => {
            this.state.dataProvider.addToSlipTranspiler(selection, eventId, marketId);
        }).bind(this);
    }
    renderArrows(renderArrows) {
        const isRTL = this.dirAnim === SiteDirection.rightToLeft;
        return returnValueHelper(this.state.dataProvider.deviceDetect.isDesktop && renderArrows, React.createElement(React.Fragment, null,
            React.createElement(CMP.Arrow, { handler: this.onClickArrowsHandler.bind(this, returnValueHelper(isRTL, "Right", "Left")), classModifier: "left", text: React.createElement(Icon, { i: "i-12 arrow-flat-left" }) }),
            React.createElement(CMP.Arrow, { handler: this.onClickArrowsHandler.bind(this, returnValueHelper(isRTL, "Left", "Right")), classModifier: "right", text: React.createElement(Icon, { i: "i-12 arrow-flat-right" }) })), false);
    }
    renderPagination(type) {
        let paginationTypeDataUat = `superbanner__pager--${type}`;
        return (React.createElement("div", { className: `rj-superbanner__pager rj-superbanner__pager--${type}`, "data-u\u0430t": paginationTypeDataUat }, this.state.dataProvider.pages.map(page => (React.createElement(CMP.PaginationItem, Object.assign({ key: page.id }, page, { handler: this.changePageClickHandler }))))));
    }
    /* istanbul ignore next */
    render() {
        let availItems = this.state.dataProvider.itemsToDisplay, isDraggingClass = this.state.isDragging ? " rj-superbanner__wrapper--is-dragging" : "", isDraggingDataUat = this.state.isDragging ? "wrapper-superbanner-dragging" : "wrapper-superbanner", hasNotFullyVisibleItems = this.state.dataProvider.getInvisibleSpace(this.state.dataProvider.calcs) !== 0;
        return availItems.length > 0 && (React.createElement("div", { className: getBannerClasses({
                scrollability: this.state.scrollable,
                siteDir: this.dirAnim,
                isMultipleItemsModeEnabled: this.cms.DisplayMultipleItems,
                draggability: this.state.dataProvider.deviceDetect.isDesktop && hasNotFullyVisibleItems && this.cms.UISetting.Draggable,
                isMobileMode: this.cms.DisplayMobileMode
            }) },
            React.createElement(CMP.WrapperShell, { autoLoopEnabled: this.cms.UISetting.autoLoop.enabled, autoLoopStart: this.boundAutoLoopStart, autoLoopStop: this.boundAutoLoopStop, isDesktop: this.state.dataProvider.deviceDetect.isDesktop },
                React.createElement("div", { className: `rj-superbanner__wrapper${isDraggingClass}`, ref: n => this.banner__wrapper = n, "data-uat": isDraggingDataUat },
                    React.createElement(Animate, Object.assign({}, this.state.anims),
                        React.createElement("div", { className: "rj-superbanner__container", ref: n => this.banner__container = n },
                            React.createElement("div", { className: "rj-superbanner__slider" }, this.renderSuperbannerItems(availItems))))),
                this.renderArrows(hasNotFullyVisibleItems && this.cms.UISetting.useArrows)),
            this.state.dataProvider.deviceDetect.isDesktop && this.cms.UISetting.Pagination &&
                hasNotFullyVisibleItems &&
                this.renderPagination(this.cms.DisplayMultipleItems ? PaginationType.lines : PaginationType.dots)));
    }
};
SuperBanner.eventsManager = new EventsManager();
SuperBanner = SuperBanner_1 = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], SuperBanner);
export { SuperBanner };
//# sourceMappingURL=SuperBanner.js.map